import * as React from 'react';
import { SVGProps } from 'react';

const IconResizeSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m1.758 10.243 8.486-8.485.707.707-8.486 8.485-.707-.707zm2.829 0 5.657-5.657.707.707-5.657 5.657-.707-.707zm2.828 0 2.829-2.829.707.708-2.829 2.828-.707-.707z" />
  </svg>
);
export default IconResizeSizeXs;
